/**
 * @file   src\mobile\components\createWantAd\SelectClient.js
 * @brief  This file is responsible for delete folder from favourites section
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { Modal } from "react-bootstrap";

const DeleteFavouriteModal = (props) => {
  const { show, onHide, handleDelete } = props;
  return (
    <Modal show={show} centered className="modalPopupstyle delete-popup">
      <Modal.Body className="text-center">
        <h3>Remove this folder from your favorited want-listings?</h3>
        <p>
          Deleting this folder will remove all of the favorited want-listings stored
          in it.
        </p>
        <div className="btn-wrap">
          <button
            type="button"
            className="btn btn-delete w-100"
            onClick={() => handleDelete()}
          >
            Confirm
          </button>
          <button
            type="button"
            className="btn btn-secondary w-100"
            onClick={() => onHide(false)}
          >
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default DeleteFavouriteModal;
